<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('QuestionsBank') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-text-field v-model="search" class="me-8" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />

                    <v-spacer />
                    <router-link :to="{ name: 'add-questionsbank'}" custom>
                        <v-btn fab small class="white--text" color="secondary" role="link">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </router-link>
                </v-card-title>
                <v-data-table :headers="headers" dense :items="questions" :search="search" class="mt-6">
                    <template v-slot:[`item.questionAr`]="{ item }">
                        {{ RemoveHtmlTags(item.questionAr) }}
                    </template>
                    <template v-slot:[`item.questionEn`]="{ item }">
                        {{ RemoveHtmlTags(item.questionEn) }}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <table>
                            <tr>

                                <td style="padding:10px">
                                    <router-link class="mx-3" :to="{ name: 'add-questionsbank', query: { id: item.id }}">
                                        <v-icon color="primary" role="link">mdi-pencil</v-icon>
                                    </router-link>
                                </td>
                                <td style="padding:10px">
                                    <v-icon color="error" @click="removeQuestion(item.id)">mdi-delete</v-icon>
                                </td>
                            </tr>
                        </table>
                    </template>

                    <template v-slot:[`item.options`]="{ item }">
                        <router-link class="mx-3" :to="{ name: 'add-questionsbank', query: { id: item.id }}">
                            <v-icon color="primary" role="link">mdi-pencil</v-icon>
                        </router-link>
                        <v-icon color="error" @click="removeQuestion(item.id)">mdi-delete</v-icon>
                    </template>


                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import { mapGetters } from 'vuex'
    import QuestionsBankService from '@/services/QuestionsBankService.js'
    import domtoimage from 'dom-to-image'
    import { useStripHtml } from '@/helpers/common.js'

    export default {

        data() {
            return {
                search: '',
                selectedSurveyId: 0,
                loading: false,
                enabled: false,
                isShared: null,
                isPublished: null,
                active: null,
                showOnHomePage: null,
                questions: [],
                mainSurveyList: [],
                userPermissionsList: [],

                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('QuestionAr'), value: 'questionAr', width: '15%', },
                    { text: this.$t('QuestionEn'), value: 'questionEn', width: '15%', },
                    { text: this.$t('NoteAr'), value: 'noteAr', width: '15%', },
                    { text: this.$t('NoteEn'), value: 'noteEn', width: '15%', },
                    { text: this.$t('Actions'), value: 'actions' }

                ],
                selectedItem: null,
                selectedTitle: ''

            }
        },

        created() {
            this.listQuestions()
        },
        mounted() {
        },
        computed: {
            ...mapGetters('user', ['language']),
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },

        },
        methods: {
            RemoveHtmlTags(text) {
                return useStripHtml(text)
            },
            getTitle(question) {
                return this.language == 'ar' || this.language == null ? question.questionAr : question.questionEn
            },
            handleAction(action, item) {
                switch (action.action) {
                    case 'edit':
                        this.editQuestion(item.id)
                        break
                    case 'delete':
                        this.removeQuestion(item.id)
                        break

                    default:
                        break
                }
            },
            editQuestion(id) {
                this.$router.push({ name: 'add-questionsbank', query: { id } })
            },

            listQuestions() {
                this.loading = true
                QuestionsBankService.listQuestions().then((res) => {
                    this.questions = res.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            async removeQuestion(id) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    QuestionsBankService.deleteQuestion(id)
                        .then((res) => {
                            this.listQuestions()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccured'), 'error')
                        }).finally(() => this.loading = false)
                }
            },


        }
    }
</script>

<style scoped>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #fff
    }
</style>